import React from "react";
import "../assets/css/PopularCourses.css";

import gameChanger from "../assets/home-page-imgs/game-changer.png";
import basics from "../assets/home-page-imgs/basics.png";
import brahmastra from "../assets/home-page-imgs/brahmastra.png";
import advance from "../assets/home-page-imgs/advance.png";

const courses = [
  {
    title: "Real Estate Game Changer",
    tagline: "Transform your mindset, skills & income",
    logo: gameChanger,
    level: "Flagship Program",
  },
  {
    title: "Real Estate Basics",
    tagline: "Strong foundation for beginners",
    logo: basics,
    level: "Foundation",
  },
  {
    title: "Brahmastra – Master Program",
    tagline: "Complete system for real estate success",
    logo: brahmastra,
    level: "Mastery",
  },
  {
    title: "Real Estate Advance",
    tagline: "Scale faster with advanced strategies",
    logo: advance,
    level: "Advanced",
  },
];

const PopularCourses = () => {
  return (
    <section className="p-courses-section">
      <div className="p-courses-container">

        {/* HEADER */}
        <div className="p-courses-header">
          <h2 className="p-courses-title">
            Signature Programs of Samriddhi Gurukul
          </h2>
          <p className="p-courses-subtitle">
            Curated learning paths designed to create confident, certified
            and high-performing real estate professionals.
          </p>
        </div>

        {/* COURSE GRID */}
        <div className="p-courses-grid">
          {courses.map((course, index) => (
            <div className="p-courses-card" key={index}>
              <span className="p-courses-badge">{course.level}</span>

              <div className="p-courses-logo-wrap">
                <img src={course.logo} alt={course.title} />
              </div>

              <h3 className="p-courses-card-title">{course.title}</h3>
              <p className="p-courses-card-text">{course.tagline}</p>

              <button className="p-courses-btn">
                Explore Program →
              </button>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="p-courses-cta">
          <button className="p-courses-main-btn">
            View All Programs
          </button>
        </div>

      </div>
    </section>
  );
};

export default PopularCourses;
